module.exports = __webpack_public_path__ + "img/number-graph.4b970f17.png";